export default [
  {
    path: '/admin/trader/rescan-jobs',
    name: 'RescanJobs',
    component: () => import('@/views/Admin/Trader/RescanJobs/Index.vue'),
    meta: {
      pageTitle: 'Rescan Jobs',
      breadcrumb: [
        { text: 'Trader', active: false },
        { text: 'Rescan Jobs', active: true },
      ],
      resource: 'edges.list',
      action: 'read',
    },
  },
]
